module.exports = __webpack_public_path__ + "7b00f5c60f432d252301ae7b59ecc0c0.png";